import MaxBar from './MaxBar';
import MediumBar from './MediumBar';
import MinBar from './MinBar';

const BarChart = (props: {
  stats: any;
  label: string;
  minRecomendation: object;
  mediumRecomendation: object;
  maxRecomendation: object;
}) => {
  const {
    stats,
    label,
    minRecomendation,
    mediumRecomendation,
    maxRecomendation,
  } = props;

  if (stats < 50) {
    return (
      <MinBar stats={stats} label={label} minRecomendation={minRecomendation} />
    );
  }
  if (50 <= stats && stats < 80) {
    return (
      <MediumBar
        stats={stats}
        label={label}
        mediumRecomendation={mediumRecomendation}
      />
    );
  } else {
    return (
      <MaxBar stats={stats} label={label} maxRecomendation={maxRecomendation} />
    );
  }
};

export default BarChart;
